import { AbstractCommand } from 'src/models/command';

class DeleteTheTaskVersionCommand extends AbstractCommand {
	readonly name = 'IFS_DesktopModule_Task_Command_Command_DeleteTaskVersionCommand';

	public constructor(aggregateId: string, aggregateVersion: string, date: string) {
		super();
		this.parameters = {
			aggregateId: aggregateId,
			aggregateVersion: aggregateVersion,
			date: date,
		};
	}
}

export { DeleteTheTaskVersionCommand };
